<h3 class="mb-3">Options and pricing configuration</h3>

<ul class="nav nav-tabs">
    <li class="nav-item" *ngFor="let p of pricing">
        <a [ngClass]="{'active' : p.active}" (click)="selectTab(p)" class="nav-link active">{{p.name}}</a>
    </li>
</ul>

<div *ngFor="let p of pricing">
    <div class="table-responsive" *ngIf="p.active">
        <table class="table table-bordered" style="width: 99%">
            <thead>
                <tr>
                    <th style="width: 20%">Name</th>
                    <th style="width: 20%">Pricing Type</th>
                    <th style="width: 10%">Enabled</th>
                    <th style="width: 50%">Pricing</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let o of p.options">
                    <td><strong>{{o.name}}</strong></td>
                    <td>
                        <span *ngIf="!o.costingMatrixBased">Fixed Cost ({{o.costType}})</span>
                        <span *ngIf="o.costingMatrixBased">Variable Cost ({{o.costType}})</span>
                    </td>
                    <td>
                        <a (click)="toggleEnabled(o)">
                            <i class="toggle fa"
                                [ngClass]="{'fa-toggle-on text-success': o.enabled, 'fa-toggle-off' : !o.enabled}"></i>
                        </a>
                    </td>
                    <td>
                        <ng-container *ngIf="o.costingMatrixBased">
                            <ng-container *ngIf="o.enabled">
                                <div class="row">
                                    <div class="col-4">Min Thickness</div>
                                    <div class="col-4">Max Thickness</div>
                                    <div class="col-3">Cost (&pound;)</div>
                                </div>
                                <div class="row mb-1" *ngFor="let pr of o.costs; let prIndex = index">
                                    <div class="col-4">
                                        <div class="input-group">
                                            <input [(ngModel)]="pr.rangeMin" type="number" class="form-control bordered"
                                                [placeholder]="'From'" />
                                            <div class="input-group-append">
                                                <span class="input-group-text">mm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="input-group">
                                            <input [(ngModel)]="pr.rangeMax" type="number" class="form-control bordered"
                                                [placeholder]="'To'" />
                                            <div class="input-group-append">
                                                <span class="input-group-text">mm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <input [(ngModel)]="pr.cost" type="number" class="form-control bordered"
                                            [placeholder]="'Price ' + o.costType" />
                                    </div>
                                    <div class="col-1 my-auto">
                                        <a (click)="removeRangeRow(o, prIndex)">
                                            <img src="assets/images/icon-trash.svg" class="opt-pricing-trash">
                                        </a>
                                    </div>
                                </div>
                                <div class="text-end mt-2" *ngIf="o.costs.length">
                                    <button class="btn btn-round btn-slim btn-primary" (click)="addRangeRow(o)">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </div>

                            </ng-container>

                        </ng-container>

                        <div class="row" *ngIf="!o.costingMatrixBased">
                            <div class="col-4">
                                <ng-container *ngIf="o.costs.length">
                                    <label>Cost (&pound;)</label>
                                    <input [(ngModel)]="o.costs[0].cost" type="number" class="form-control bordered"
                                        [placeholder]="'Price ' + o.costType" />
                                </ng-container>
                            </div>
                            <div class="col-6"></div>
                            <div class="col-1"></div>
                        </div>

                    </td>
                </tr>
            </tbody>
        </table>

    </div>
</div>

<ng-container *ngIf="!areActionButtonsHidden">
    <div class="text-end">
        <button (click)="setSupplierPricing()" class="btn btn-round btn-primary mt-4" type="button">
            Complete
        </button>
    </div>
    <div class="mt-2 text-end">
        <p>Click 'Complete' to save options and complete the supplier process</p>
    </div>
</ng-container>
